import * as Yup from 'yup';

export const CouponValidationSchema = Yup.object().shape({
	Coupon_Code: Yup.string().required('Coupon Code is required'),
	Coupon_Name: Yup.string().required('Coupon Name is required'),
	Coupon_Type: Yup.string().required('Coupon Type is required'),
	Discount_Type: Yup.string().required('Discount Type is required'),
});
